import {Component, OnDestroy, OnInit} from '@angular/core';
import {
  GlobalEventDispatcherService
} from "../../../../../shared/services/global-event-dispatcher/global-event-dispatcher.service";
import {Store} from "@ngrx/store";
import * as fromStore from "../../../../../store";
import {HostingService} from "../../../../../websites/website/hosting/hosting.service";
import {UserService} from "../../../../../user/user.service";
import {GoogleAnalyticsService} from "../../../../../shared/services/google-analytics/google-analytics.service";
import {WebsiteService} from "../../../../../websites/website.service";
import {CreateAIProcessStepSlug} from "./components/create-ai-process/create-ai-process.component";
import {Website} from "../../../../../websites/website/website";
import {ActivityStatus} from "../../../../../activities/activity";
import {GlobalEvent} from "../../../../../shared/services/global-event-dispatcher/global-event";
import {ActivatedRoute, Router} from "@angular/router";
import {CreateAiBase} from "../create-ai-base";
import {filter, first, takeUntil} from "rxjs/operators";
import {AuthService} from "../../../../../auth/auth.service";
import {Utils} from "../../../../../shared/utils/utils";
import {Config} from "../../../../../config/config";
import {DashboardUtils} from "../../../../../shared/utils/dashboard-utils";

const ADDING_ACTIVITIES =
  ['Extracting content.', 'Creating layout.', 'Extracting layout styles.',
    'Creating widgets.', 'Preparing template archive.', 'Website template is ready.'];
@Component({
    selector: 'db-create-ai-builder',
    templateUrl: './create-ai-builder.component.html',
    styleUrls: ['./create-ai-builder.component.scss'],
    standalone: false
})
export class CreateAiBuilderComponent extends CreateAiBase implements OnInit, OnDestroy {
  public recreateUrl: string;
  public step: CreateAIProcessStepSlug = 'installing';
  public override frontUrl: string;
  constructor(
    protected _globalEventDispatcher: GlobalEventDispatcherService,
    protected override _store: Store<fromStore.DbStoreState>,
    protected override _hostingService: HostingService,
    protected override _userService: UserService,
    protected override _googleAnalyticsService: GoogleAnalyticsService,
    private _websiteService: WebsiteService,
    private _router: Router,
    private _route: ActivatedRoute,
    private _authService: AuthService,
  ) {
    super(_globalEventDispatcher, _store, _hostingService, _userService, _googleAnalyticsService);
  }

  override ngOnInit() {
    super.ngOnInit();
    this._getRecreateOngoingActivity();
  }

  override ngOnDestroy() {
    super.ngOnDestroy();
  }

  public startRecreation(url: string): void {
    this.recreateUrl = url;
    super.startRecreationProcess();
  }

  override createWebsiteObserver(): void {
    if (!this.websiteId || !this.recreateUrl) {
      return this.errorHandler();
    }
    super.createWebsiteObserver();
  }

  override getWebsiteObserver(website: Website): void {
    this.frontUrl = website.site_url;
  }

  override recreateWebsite(): void {
    super.recreateWebsite();
    this.step = 'recreating';
    this._websiteService.runAiBuilder(this.websiteId, [this.recreateUrl], 'Homepage', 'publish', null, true)
      .pipe(
        first(response => !!response)
      )
      .subscribe(response => {
        if (!response.success) {
          return this.errorHandler();
        }
      });
  }

  private _getRecreateOngoingActivity(): void {
    this._store.select(fromStore.getOngoingActivity)
      .pipe(
        takeUntil(this._destroyStream$),
        filter(activity => activity && activity.websiteId === this.websiteId)
      )
      .subscribe(activity => {
        if (ADDING_ACTIVITIES.includes(activity.message)) {
          this.step = 'adding';
        }
        if (activity.action === 'install_template') {
          this.step = 'finishing';
        }
        if (activity.action === 'install_hosted_template') {
          if (activity.status === ActivityStatus.DONE) {
            this._globalEventDispatcher.dispatchEvent(GlobalEvent.hideOnboardingBackButton, 1);
            this.step = 'done';
            this.userLocalStorage['onboardingPassed' + this.websiteId] = true;
            this._userService.setToLocal({...this.userLocalStorage, setupAiRecreation: null});
            if (this.user && (this.user.isSuspected || (this.userSubscription && !this.user.hostingTrialExpired && this.website && !this.website?.isAiBuilderDemo && (this.userSubscription.trialClient || this.userSubscription.freeBaseClient)))) {
              this._hostingService.whiteListIp(this.website.id, this.website.site_url);
              const websiteUrl = `${this.website?.site_url}/?trial_hosted_flow=1${this.website?.isEcommerceWebsite ? '&ecommerce=1' : ''}`;
              const previewLink = DashboardUtils.generateWpAdminRedirectorUrl(this.website?.id, websiteUrl, this.user?.email);
              setTimeout( () => {
                window.open(previewLink, '_self');
              }, 3000);
            }
          } else {
            this.step = 'finishing';
          }
        }
        if (activity.status === ActivityStatus.FAILED) {
          this.recreationProcess = false;
          this.errorHandler();
        }
      });
  }

  protected override errorHandler(): void {
    super.errorHandler();
  }

}
